module.exports = __webpack_public_path__ + "img/5.f2286f25.png";